import { combineReducers } from "redux";

// Reducers
import sampleReducer from "./SampleReducer/SampleReducer";
import geolocationReducer from "./GeolocationReducer/GeolocationReducer";

const rootReducer = combineReducers({
    sample: sampleReducer,
    geolocation: geolocationReducer,
});

export default rootReducer;